import { css } from "../../../../../../../styled-system/css";

export const styles = {
  reportLink: () =>
    css({
      textDecoration: "none",
    }),
};
